import React, { useEffect, useState } from 'react';
import MDBox from 'components/MDBox';
import Grid from '@mui/material/Grid';
import { useForm } from 'react-hook-form';
import Typography from '@mui/material/Typography';
import MDTypography from 'components/MDTypography';
import { FormInputText } from 'components/Common/Forms/FormTextField';
import {
  teacherLastContactedBy,
  teacherLastUpdatedBy,
  teacherNotes,
} from 'constants';
import { AccordianContainer } from 'components/Ui/styled';
import { AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import StudentProfileNote from 'layouts/studentManagement/components/studentProfile/components/studentProfileTabs/StudentProfileNote';
import { useSelector, useDispatch } from 'react-redux';
import { getSearchStudentDetails } from 'layouts/students/service/studentsApi';
import { setStudentProfileDetails } from 'layouts/studentManagement/store/studentProfileDetailsSlice/studentProfileDetailsSlice';
import { useNotification } from 'utils/commonUtils';

const ParentContactInfo = () => {
  const dispatch = useDispatch();

  const { NotificationPopup, handleErrorResponse } = useNotification();

  const [isExpanded, setIsExpanded] = useState(true);
  const studentId = useSelector(
    (state) => state.studentDetails?.item?.studentId
  );

  const studentProfileDetails = useSelector(
    (state) => state?.studentProfileDetails
  );

  const { profile } = studentProfileDetails || {};
  const { note, resourceId } = profile || {};

  const defaultValue = {
    parent1Name: '',
    parent1PhoneNumber: '',
    parent1Email: '',
    parent1Address: '',
    parent2Name: '',
    parent2PhoneNumber: '',
    parent2Email: '',
    parent2Address: '',
    preferedContactMethod: '',
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
  });

  const { control } = useFunction;

  useEffect(() => {
    fetchStudentNoteInfo();
  }, []);

  const handleAccordionChange = () => {
    setIsExpanded(!isExpanded);
  };

  const fetchStudentNoteInfo = async () => {
    try {
      const studentNoteInfoData = await getSearchStudentDetails(studentId);
      dispatch(setStudentProfileDetails(studentNoteInfoData));
    } catch (error) {
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  return (
    <>
      <MDBox pt={1}></MDBox>
      <Typography variant="h6">{teacherLastContactedBy}</Typography>
      <MDTypography variant="h6">Parent Contact Information</MDTypography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <FormInputText
            name="parent1Name"
            type="text"
            control={control}
            label="Parent 1 Name"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FormInputText
            name="parent1PhoneNumber"
            type="text"
            control={control}
            label="Parent 1 Phone number"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FormInputText
            name="parent1Email"
            type="text"
            control={control}
            label="Parent 1 Email"
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <FormInputText
            name="parent1Address"
            type="text"
            control={control}
            label="Parent 1 Address"
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <FormInputText
            name="parent2Name"
            type="text"
            control={control}
            label="Parent 2 Name"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FormInputText
            name="parent2PhoneNumber"
            type="text"
            control={control}
            label="Parent 2 Phone number"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FormInputText
            name="parent2Email"
            type="text"
            control={control}
            label="Parent 2 Email"
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <FormInputText
            name="parent2Address"
            type="text"
            control={control}
            label="Parent 2 Address"
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <FormInputText
            name="preferedContactMethod"
            type="text"
            control={control}
            label="Prefered contact method (Email/Phone)"
          />
        </Grid>
      </Grid>

      <Grid container spacing={1}>
        <Grid item xs={12} md={9.5}>
          <AccordianContainer
            defaultExpanded={false}
            expanded={isExpanded}
            onChange={handleAccordionChange}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography variant="d7" data-testid="Note_Accordion">
                Note
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <StudentProfileNote
                note={note}
                resourceId={resourceId}
                fetchStudentNote={fetchStudentNoteInfo}
              />
            </AccordionDetails>
          </AccordianContainer>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">{teacherLastUpdatedBy}</Typography>
          <Typography variant="h6">{teacherNotes}</Typography>
        </Grid>
      </Grid>
      <MDBox pt={2}></MDBox>
      <NotificationPopup />
    </>
  );
};

export default ParentContactInfo;
